<template>
  <div>
    <field-wrapper label="State" v-model="values.states" :error="errors.states" :options="options.states"
                   :multiple="true"
                   type="select"
                   :close-on-select="false"/>
    <div class="text-muted">
      <div>
        This parameter is useful in conjuction with updated when you cache events and are interested in retrieving
        a list of all events that have changed since a specific date and time.
      </div>
      <div>
        <br/>
        <code>active</code>: the event is published and valid.
        <br/>

        <code>deleted</code>: the event was removed, either because it was cancelled or is a duplicate.
      </div>
      <br/>
      By default, only <code>active</code> events show in the search results.
    </div>

  </div>
</template>
<script>
  import fieldWrapper from '@/components/shared/field-wrapper'
  import { FILTER_OPTIONS } from '@/app/wdc/form/fixtures'

  export default {
    components: {
      fieldWrapper
    },
    props: {
      values: Object,
      errors: Object
    },
    name: 'stateFilter',
    data () {
      return {
        options: FILTER_OPTIONS
      }
    }
  }
</script>
<style>
</style>
